import { render, staticRenderFns } from "./MealManagement.vue?vue&type=template&id=42b7d22e&"
import script from "./MealManagement.vue?vue&type=script&lang=js&"
export * from "./MealManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports